import { render, staticRenderFns } from "./inputMessage.vue?vue&type=template&id=874637ec&scoped=true"
import script from "./inputMessage.vue?vue&type=script&lang=js"
export * from "./inputMessage.vue?vue&type=script&lang=js"
import style0 from "./inputMessage.vue?vue&type=style&index=0&id=874637ec&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874637ec",
  null
  
)

export default component.exports